/* Interactions only. All purchases use the existing V7 Shopify commerce bridge. */
(() => {
  'use strict';
  function initTabs(root, selector, vertical = false) {
    if (root.dataset.v8Bound) return;
    root.dataset.v8Bound = 'true';
    const tabs = [...root.querySelectorAll(selector)];
    const activate = (selected, focus = false) => {
      tabs.forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
      if (focus) selected.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        const next = vertical ? 'ArrowDown' : 'ArrowRight';
        const previous = vertical ? 'ArrowUp' : 'ArrowLeft';
        let target;
        if (event.key === next) target = (index + 1) % tabs.length;
        if (event.key === previous) target = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = tabs.length - 1;
        if (target !== undefined) { event.preventDefault(); activate(tabs[target], true); }
      });
    });
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-v8-tabs]').forEach(root => initTabs(root, '[data-v8-tab]'));
    scope.querySelectorAll('.v8-scents').forEach(root => initTabs(root, '[data-v8-scent]', true));
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.v8-quick-form');
    if (!form || !window.MDMCart) return;
    event.preventDefault();
    const button = form.querySelector('[data-v8-add]');
    if (!button || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try { await window.MDMCart.add(button.dataset.v8Add, 1); }
    finally { button.disabled = false; button.removeAttribute('aria-busy'); }
  });
})();
